import { EMBER, FIRE, USDC,WNATIVE } from '@emberswap/emberswap-sdk2/dist/constants'
import { Native } from '@emberswap/emberswap-sdk2/dist/entities'
import { ChainId } from "@emberswap/emberswap-sdk2/dist/enums"

export const COMMON_BASES = {
  [ChainId.SMARTBCH]: [
    Native.onChain(ChainId.SMARTBCH),
    WNATIVE[ChainId.SMARTBCH],
    EMBER[ChainId.SMARTBCH],
    FIRE[ChainId.SMARTBCH],
    USDC[ChainId.SMARTBCH],
  ],
  [ChainId.SMARTBCH_TESTNET]: [
    Native.onChain(ChainId.SMARTBCH_TESTNET),
    WNATIVE[ChainId.SMARTBCH_TESTNET],
    EMBER[ChainId.SMARTBCH_TESTNET],
    FIRE[ChainId.SMARTBCH_TESTNET],
  ],
  [ChainId.BSC]: [Native.onChain(ChainId.BSC), WNATIVE[ChainId.BSC]],
  [ChainId.BSC_TESTNET]: [Native.onChain(ChainId.BSC_TESTNET), WNATIVE[ChainId.BSC_TESTNET]],
} as const

export const COMMON_BASES_IDS = Object.entries(COMMON_BASES).reduce<Record<string, string[]>>((acc, [chain, tokens]) => {
  const chainId = chain
  acc[chainId] = Array.from(
    new Set(
      tokens.map((token) =>
        token.id
      )
    )
  )
  return acc
}, {} as Record<ChainId, string[]>)
